import type { FC } from "react";
import { Button, Card, Spacing, Text } from "@huub-web/ui";
import type { ThemeSlotPropsMap } from "@huub-web/ui/contexts/ThemeSlotContext";
import { useTranslation } from "react-i18next";

import { HouseGraphicsBackground } from "../../HouseGraphicsBackground";

export const DefaultMaximumMortgageResultBanner: FC<
  ThemeSlotPropsMap["maximumMortgageResultBanner"]
> = ({
  resultType,
  hasPartner,
  advisorAction,
  thisSubjectKey,
  theSubjectKey,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      variant="gradient"
      leading={<HouseGraphicsBackground variant="banner" />}
      overflowHidden
    >
      <Text as="h3" variant="displayM" bold>
        {t(
          `maxMortgageWizard.result.${resultType}.banner.title.${hasPartner ? "plural" : "singular"}`,
        )}
      </Text>
      <Text as="p">
        {t(
          `maxMortgageWizard.result.${resultType}.banner.description.${hasPartner ? "plural" : "singular"}`,
          {
            thisSubject: t(thisSubjectKey),
            theSubject: t(theSubjectKey),
          },
        )}
      </Text>
      <Spacing />
      <Button
        variant="background"
        alignSelf="flex-start"
        as={advisorAction?.href ? "a" : "button"}
        href={advisorAction?.href}
        tracking={advisorAction?.tracking}
        onClick={advisorAction?.onClick}
      >
        {advisorAction?.value ??
          t(`maxMortgageWizard.result.${resultType}.cta.banner`)}
      </Button>
    </Card>
  );
};
